import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Navigate from "../../../../shared/navigation/navigate";
import LoaderButton from "../../../../shared/components/buttons/LoaderButton";
import YesNoModal from "../../../../shared/components/modals/YesNoModal";
import jobStatus from "../../../../shared/variables/job-status";
import { golferInformation, setPassword } from "../../actions";
import DisplayStatusModal from "../common/DisplayStatusModal";
import Loader from "../../../../shared/components/loaders/Loader";
import { Formik } from "formik";
import * as Yup from "yup";
import TurnstileWidget from "../../../../shared/components/widgets/TurnstileWidget";

class SetNewPassword extends Component {
  state = {
    setStatus: 0,
    setStatusMessage: "",
    showPassword: false,
    turnstileToken: null,
  };

  validationSchema = Yup.object({
    password: Yup.string()
      .required("Password must be at least 6 characters")
      .min(6, "Password must be at least 6 characters"),

    confirmPassword: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "Your password does not match"
    ),
  });

  componentDidMount() {
    const {
      match: {
        params: { token },
      },
    } = this.props;
    if (token) {
      this.props.golferInformation({ token });
    } else {
      this.redirectToHome();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { setPasswordStatus } = nextProps;
    if (
      setPasswordStatus !== this.props.setPasswordStatus &&
      setPasswordStatus === jobStatus.FAILED
    ) {
      this.setState({
        setStatus: 1,
        setStatusMessage: "The set password token is invalid.",
      });
    }

    if (
      setPasswordStatus !== this.props.setPasswordStatus &&
      setPasswordStatus === jobStatus.SUCCESS
    ) {
      this.setState({
        setStatus: 2,
        setStatusMessage: "You have successfully reset your password.",
      });
    }
  }

  redirectToHome = () => Navigate.toPath("/");

  onSubmit = (values, { setSubmitting }) => {
    const {
      match: {
        params: { token },
      },
    } = this.props;
    setSubmitting(false);

    this.props.setPassword({
      password: values.password,
      reset_password_token: token,
      golfer_user_accepted_terms: values.acceptedTerms,
      turnstile_token: this.state.turnstileToken,
    });
  };

  onToggleShowPassword = () =>
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));

  onTurnstileTokenVerified = (token) =>
    this.setState({ turnstileToken: token });

  renderForm(options, user) {
    return (
      <Fragment>
        <div className="forgot-form">
          <div className="row">
            <div className="col is-full">
              <label className="disable" htmlFor="name">
                Name
              </label>
              <input type="text-disabled" value={user.name} />
            </div>
          </div>
          <div className="row">
            <div className="col is-full">
              <label className="disable" htmlFor="email">
                Email
              </label>
              <input type="text-disabled" value={user.email} />
              <span className="error">
                {options.touched.email ? options.errors.email : ""}
              </span>
            </div>
          </div>
          <br />
          <label className="disable">Set New Password</label>
          <div className="row">
            <div className="col is-full">
              <label className="black" htmlFor="password">
                New Password
              </label>
              <div className="show_password_wrapper">
                <input
                  type={this.state.showPassword ? "text" : "password"}
                  id="password"
                  value={options.values.password}
                  name="password"
                  onBlur={options.handleBlur}
                  onChange={options.handleChange}
                />
                {options.values.password && options.values.password.length > 0 && (
                  <div className="show_password">
                    <button
                      onClick={this.onToggleShowPassword}
                      className="btn lnk no-underline show_button"
                    >
                      {this.state.showPassword ? "HIDE" : "SHOW"}
                    </button>
                  </div>
                )}
              </div>
              <span className="error">
                {options.touched.password ? options.errors.password : ""}
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col is-full">
              <label className="black" htmlFor="confirmPassword">
                Confirm New Password
              </label>
              <div className="show_password_wrapper">
                <input
                  type={this.state.showPassword ? "text" : "password"}
                  id="confirmPassword"
                  value={options.values.confirmPassword}
                  name="confirmPassword"
                  onBlur={options.handleBlur}
                  onChange={options.handleChange}
                />
                {options.values.confirmPassword &&
                  options.values.confirmPassword.length > 0 && (
                    <div className="show_password">
                      <button
                        onClick={this.onToggleShowPassword}
                        className="btn lnk no-underline show_button"
                      >
                        {this.state.showPassword ? "HIDE" : "SHOW"}
                      </button>
                    </div>
                  )}
              </div>
              <span className="error">
                {options.touched.confirmPassword
                  ? options.errors.confirmPassword
                  : ""}
              </span>
            </div>
          </div>

          <TurnstileWidget
            saveTurnstileToken={this.onTurnstileTokenVerified}
            action="ghin-set-new-password"
          />

          <br />
          <br />
          <div className="row">
            <div className="col is-2-of-3 h-centered">
              <LoaderButton
                type="submit"
                className="btn fill cardinal"
                onClick={options.handleSubmit}
                disabled={!options.isValid || this.state.turnstileToken == null}
                loading={String(
                  this.props.setPasswordStatus === jobStatus.PROCESSING
                )}
              >
                FINISH
              </LoaderButton>
            </div>
          </div>
          <div className="row">
            <div className="col is-full">
              <button
                onClick={this.props.forgotLoginAction}
                className="btn lnk white"
              >
                Forgot login information?
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  renderContainer() {
    const { user } = this.props;
    return (
      <div className="auth__container">
        <div className="forgot-login no-padding">
          {
            <Formik
              onSubmit={this.onSubmit}
              validationSchema={this.validationSchema}
            >
              {(options) => this.renderForm(options, user)}
            </Formik>
          }
        </div>
      </div>
    );
  }

  render() {
    const { setStatus, setStatusMessage } = this.state;
    const { userErrorInfo, getUserStatus } = this.props;
    return (
      <Fragment>
        <div className="page_container create-profile-page">
          <div className="box-content">
            <h1>Set New Password</h1>
          </div>
          <div className="box-panel center">
            {getUserStatus !== jobStatus.SUCCESS ? (
              <Loader />
            ) : (
              this.renderContainer()
            )}
          </div>
        </div>
        <DisplayStatusModal
          status={setStatus}
          statusMessage={setStatusMessage}
          onOk={() =>
            this.setState({
              setStatus: 0,
            })
          }
        />
        <YesNoModal
          onConfirm={this.redirectToHome}
          onAbort={this.redirectToHome}
          isOpen={!!userErrorInfo}
          isYesVisible={true}
          isNoVisible={false}
          yesTitle="Ok"
        >
          <p>{userErrorInfo}</p>
        </YesNoModal>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authReducer }) => ({
  getUserStatus: authReducer.golferInformationReducer.status,
  setPasswordStatus: authReducer.setPasswordReducer.status,
  user: authReducer.golferInformationReducer.user,
  userErrorInfo: authReducer.golferInformationReducer.userError,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ golferInformation, setPassword }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SetNewPassword);
